import {
    BRANCHES_VENDOR_FETCHING,
    BRANCHES_VENDOR_SUCCESS,
    BRANCHES_VENDOR_FAILED
} from "../actions/types";

  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case BRANCHES_VENDOR_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case BRANCHES_VENDOR_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case BRANCHES_VENDOR_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }